import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EvaluationTaskService {
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {
  }

  getAll(params: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/ListEvaluationTasks`, { params });
  }

  createEvaluationTask(data: any): any {
    return this.http.post(`${environment.apiUrl}/EvaluationTask/CreateEvaluationTask`, data);
  }

  getBranchComplianceRate(evaluationTaskId): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetBranchComplianceRate?evaluationTaskId=${evaluationTaskId}`);
  }

  getRelatedTracks(hubCode): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetRelatedTracks?hubCode=${hubCode}`);
  }

  getRelatedGroups(params: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetRelatedGroups`, { params });
  }

  getRelatedAmbassadros(params: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetRelatedAmbassadros`, { params });
  }

  getListEvaluationTaskByAdmin(params: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/ListEvaluationTaskByAdmin`, { params });
  }

  getQuestionsByTaskId(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetQuestionsByTaskId?taskId=${taskId}`);
  }

  getTaskLogs(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetTaskLogs?taskId=${taskId}`);
  }

  removeTask(params: any) {
    return this.http.post(`${environment.apiUrl}/EvaluationTask/RemoveTask`, null, { params });
  }

  getListEvaluationTasksByAmbassador(params: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/ListEvaluationTasksByAmbassador`, { params });
  }

  getTaskDetails(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetTaskDetails?taskId=${taskId}`);
  }
  getAvailableActions(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetAvailableActions?evaluationTaskId=${taskId}`);
  }
  getAllTaskComments(taskId: any): any {
    return this.http.get(`${environment.apiUrl}/EvaluationTask/GetAllTaskComments?taskId=${taskId}`);
  }

  addTaskComment(data: any): any {
    return this.http.post(`${environment.apiUrl}/EvaluationTask/AddTaskComment`, data);
  }
  updateTaskComment(data: any): any {
    return this.http.put(`${environment.apiUrl}/EvaluationTask/UpdateTaskComment`, data);
  }
  deleteTaskComment(commentId: any): any {
    return this.http.delete(`${environment.apiUrl}/EvaluationTask/DeleteTaskComment?commentId=${commentId}`);
  }


  changeTaskStatus(data: any): any {
    return this.http.post(`${environment.apiUrl}/EvaluationTask/ChangeTaskStatus`, data);
  }

  saveTaskDraftAnswers(data: any): any {
    return this.http.post(`${environment.apiUrl}/EvaluationTask/SaveTaskDraftAnswers`, data);
  }

  saveTaskAnswers(data: any): any {
    return this.http.post(`${environment.apiUrl}/EvaluationTask/SaveTaskAnswers`, data);
  }

  runAi(taskId: number): any {
    return this.http.post(`${environment.apiUrl}/EvaluationTask/RunAi?taskId=${taskId}`, null);
  }
}
